/**
 * Global UI class
 */

window.$      = window.jQuery = require('jquery/dist/jquery.min');
window.Popper = require('popper.js/dist/umd/popper.min');
require('bootstrap/dist/js/bootstrap.bundle');
require('jQuery.serializeObject');

/**
 * Initialize a container of HTML
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    // Initialize tooltips
    $('[data-toggle="tooltip"]').tooltip();
};

/**
 * Initialize toggling of DOM elements for changes in input values
 */
const initializeToggles = function() {
    var toggle = function(name, value, $scope, $element) {
        name = name.replace(/\[/g, '-').replace(/]/g, '').replace(/_/g, '-');
        $('[data-toggle-' + name + ']', $scope).hide();
        $('[data-toggle-' + name + ']', $scope).each(function() {
            var toggleValues = $(this).data('toggle-' + name);
            if (!Array.isArray(toggleValues)) {
                toggleValues = [toggleValues];
            }
            for (const toggleValue of toggleValues) {
                if (value == toggleValue) {
                    $(this).show();
                }
            }
        });

        if ($element.data('toggle') === 'disable') {
            var $invisible = $('[data-toggle-' + name + ']:not(:visible)', $scope);
            $('input, select', $invisible).attr('disabled', '');

            var $visible = $('[data-toggle-' + name + ']:visible', $scope);
            $('input:visible, select:visible, label:visible input:checkbox, label:visible input:radio', $visible).removeAttr('disabled');
        }
    };

    $(document).on('change', 'input[data-toggle],select[data-toggle]', function() {
        var $elem          = $(this);
        var toggleSelector = $elem.data('toggle-selector') || $elem.attr('name');
        var $scope         = $elem.closest('form');

        var value = $elem.val();
        if ($elem.is(':checkbox')) {
            value = $elem.is(':checked') ? 1 : 0;
        } else if ($elem.is(':radio')) {
            if ($elem.is(':checked')) {
                value = $elem.val();
            } else {
                return;
            }
        }
        toggle(toggleSelector, value, $scope, $elem);
    });
    $(document).on('keyup', 'input:not(:checkbox, :radio)[data-toggle]', function() {
        var $elem          = $(this);
        var toggleSelector = $elem.data('toggle-selector') || $elem.attr('name');
        var $scope         = $elem.closest('form');
        var value          = $elem.val();

        toggle(toggleSelector, value, $scope, $elem);
    });

    $(document).ready(function() {
        $('input[data-toggle],select[data-toggle]').change();
    });
};

/**
 * Initialize retention check form functionality
 */
const initializeRetainableForm = function($container) {
    $('.retainable-form', $container).each(function() {
        var $form            = $(this);
        var recaptchaSiteKey = $form.data('recaptcha-sitekey');

        if (typeof recaptchaSiteKey !== 'undefined') {
            //initialize recaptcha
            var action = $form.data('recaptcha-action');
            $form.submit(function(e) {
                e.preventDefault();
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(recaptchaSiteKey, {action: action}).then(function(token) {
                        $form.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
                        submitFormThroughAjax($form);
                    });
                });
                return false;
            });
        } else {
            $form.submit(function(e) {
                e.preventDefault();
                submitFormThroughAjax($form);
                return false;
            });
        }

        //show/hide fields depending on selected business
        var $parent = $form.parent();
        $parent.on('change', '#business', function() {
            var provider = $(this).val();
            $form.find('[data-providers]').each(function() {
                var activeFor = $(this).data('providers');
                var wrapper   = $(this).closest('.form-group');
                wrapper.toggle(activeFor.length === 0 || activeFor.indexOf(provider) !== -1);
            });
        });
        $('#business').trigger('change');
    });
}

/**
 * Submit form through ajax and replace with result
 */
const submitFormThroughAjax = function($form) {
    $form.addClass('loading').find(':input').blur();
    const data   = $form.serializeObject();
    const action = $form.attr('action');

    $.ajax({
        url:     $form.attr('action'),
        method:  $form.attr('method'),
        data:    data,
        headers: {
            'App-XHR-Form': '?1',
        }
    }).done((data, statusText, xhr) => {
        const $content = $(data);
        $form.replaceWith($content);
        initializeRetainableForm($('body'));
    }).fail((xhr) => {
        $form.removeClass('loading');
        if (xhr.statusText === 'abort') {
            return;
        }
        alert('Er ging iets mis met het versturen. Herlaad de pagina en probeer het opnieuw.');
    });
}

// Export initialization
export default {
    initializeContainer: initializeContainer,
    initialize:          function() {
        $(document).ready(function() {
            // Initialize the body as a container
            let $body = $('body');
            initializeContainer($body);
            initializeToggles();
            initializeRetainableForm($body);
        });
    },
};



// WEBPACK FOOTER //
// ./build/script/src/ui.js